var createRunParameters = function createRunParameters(contactId, parameters) {
  var runParameters = [];
  if (contactId) runParameters.push({
    name: 'ContactId',
    value: contactId
  });
  if (!parameters) return runParameters;
  if (Array.isArray(parameters)) parameters.filter(function (param) {
    return !!param.name;
  }).forEach(function (param) {
    runParameters.push(param);
  });else if (typeof parameters === 'object') Object.keys(parameters).forEach(function (key) {
    return runParameters.push({
      name: key,
      value: parameters[key]
    });
  });
  return runParameters;
};

var getParameterValue = function getParameterValue(parameters, name) {
  if (!parameters || !name) return;

  if (Array.isArray(parameters)) {
    var parameter = parameters.find(function (p) {
      return compareInsensitive(p.name, name);
    });
    return parameter && parameter.value;
  }

  if (typeof parameters === 'object') {
    var parameterName = Object.keys(parameters).find(function (p) {
      return compareInsensitive(p, name);
    });
    return parameterName && parameters[parameterName];
  }
};

var createFormContext = function createFormContext(context, parameters) {
  var formContext = context || {};
  parameters.forEach(function (param) {
    formContext[param.name] = param.value;
  });
  return formContext;
};

var compareInsensitive = function compareInsensitive(left, right) {
  if (!left || !right) return left === right;
  return left.toLowerCase() === right.toLowerCase();
};
/**
 * @param {boolean} enableAdvanced
 * @param {Array<{name:string, value:string}>} parameters
 * @param {() => any} onJobDeleted
 * @param {(jobSummary:import("./types").JobSummary) => any}
 * @returns {import("../context/types").RunOptions}
 */


var createRunOptions = function createRunOptions(enableAdvanced, parameters, onJobDeleted, onJobUpdated) {
  var runOptions = {
    enableAdvanced: enableAdvanced,
    onJobDeleted: onJobDeleted,
    onJobUpdated: onJobUpdated
  };
  var workItemParam = parameters.find(function (p) {
    return p.name.toLowerCase() === 'workitem';
  });

  if (workItemParam) {
    var parts = workItemParam.value.split(':');
    runOptions.workItemWorkspace = parts.length > 1 ? parts[0] : '';
    runOptions.workItemPath = parts.length > 1 ? parts[1] : parts[0];
  }

  return runOptions;
};

export default {
  getParameterValue: getParameterValue,
  createFormContext: createFormContext,
  createRunParameters: createRunParameters,
  createRunOptions: createRunOptions
};